import UpdatePostContent from "../../../content/post/updatePost";
import { Layout } from "../../../layout/page";

export function UpdatePost() {
  return (
    <Layout>
      <UpdatePostContent />
    </Layout>
  );
}
